
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)","fill":"#6B6B6B"}},[_c('path',{attrs:{"d":"M14.167 16H1.833A1.835 1.835 0 010 14.167v-11c0-1.012.822-1.834 1.833-1.834h12.334c1.011 0 1.833.822 1.833 1.834v11A1.835 1.835 0 0114.167 16zM1.833 2.333A.834.834 0 001 3.167v11c0 .459.374.833.833.833h12.334c.459 0 .833-.374.833-.833v-11a.834.834 0 00-.833-.834H1.833z"}}),_c('path',{attrs:{"d":"M15.5 6.333H.5a.5.5 0 010-1h15a.5.5 0 010 1zM3.833 4a.5.5 0 01-.5-.5v-3a.5.5 0 011 0v3a.5.5 0 01-.5.5zM12.166 4a.5.5 0 01-.5-.5v-3a.5.5 0 011 0v3a.5.5 0 01-.5.5z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h16v16H0z"}})])])])
          )
        }
      }
    